export default __webpack_public_path__ + "static/media/Initiation.afd0bf27.png";